module.exports = __webpack_public_path__ + "static/media/logo.dbb388be.png";